import React, { useMemo } from "react";
import { Box, Container } from "@material-ui/core";
import Preloader from "../../Common/Preloader";
import { useFindWagerQuery } from "../../../api/wager";
import Item from "../../Halls/View/item";
import FortuneWheelTable from "./fortune-wheel-table";
import { useTranslation } from "react-i18next";
import { PaymentBonusValue } from "../../../interfaces";
import { games } from "../games-data";

interface WagersProps {
    hall_id: number;
}

const WagersView: React.FC<WagersProps> = ({ hall_id }) => {
    const [t] = useTranslation();
    const { data: wager, isLoading } = useFindWagerQuery(hall_id);

    // Хелпер для безопасного рендера бонуса (поддерживает и старый, и новый форматы)
    const renderBonus = useMemo(() => (bonus?: PaymentBonusValue) => {
        if (bonus === undefined || bonus === null) return "0%";

        const isComplex = typeof bonus === "object";
        const amount = isComplex ? bonus.amount : bonus;
        const fs = isComplex ? bonus.free_spins : null;

        let mainText = `${amount}%`; // Сохраняем знак %, как было в оригинале

        // Если есть фриспины и указано их количество
        if (fs && fs.count) {
            const game = games.find((g) => g.id === fs.game_id);
            const gameName = game ? game.title : (fs.game_id ? `ID: ${fs.game_id}` : "Неизвестная игра");

            let fsInfo = `${fs.count} FS в ${gameName}`;

            const extras = [];
            if (fs.line_bet) extras.push(`ставка: ${fs.line_bet}`);
            if (fs.bet_level) extras.push(`ур: ${fs.bet_level}`);

            if (extras.length > 0) {
                fsInfo += ` (${extras.join(", ")})`;
            }

            return (
                <span>
                    {mainText}
                    <br />
                    <span style={{ fontSize: "0.85em", color: "#888" }}>
                        + {fsInfo}
                    </span>
                </span>
            );
        }

        return mainText;
    }, []);

    return (
        <Box display="flex" flexDirection="column" justifyContent="space-between" style={{ width: "100%" }}>
            {!wager || isLoading ? (
                <Preloader />
            ) : (
                <Container>
                    <Item name={"ru.halls.wager.first_payment_percent"} value={`${wager.first_payment_percent}%`} />
                    <Item name={"ru.halls.wager.first_payment_bonus"} value={renderBonus(wager.first_payment_bonus)} />

                    <Item name={"ru.halls.wager.second_payment_percent"} value={`${wager.second_payment_percent}%`} />
                    <Item name={"ru.halls.wager.second_payment_bonus"} value={renderBonus(wager.second_payment_bonus)} />

                    <Item name={"ru.halls.wager.third_payment_percent"} value={`${wager.third_payment_percent}%`} />
                    <Item name={"ru.halls.wager.third_payment_bonus"} value={renderBonus(wager.third_payment_bonus)} />

                    <h2>{t("ru.halls.wager.referral.title")}</h2>
                    <Item name={"ru.halls.wager.referral.percent"} md={12} value={`${wager.referral?.percent ?? 0}%`} />
                    <Item name={"ru.halls.wager.referral.wager"} md={12} value={`${wager.referral?.wager ?? 0}%`} />
                    <Item
                        name={"ru.halls.wager.referral.period"}
                        md={12}
                        value={wager.referral?.period === 0 ? "отключено" : `${Math.floor((wager.referral?.period ?? 0) / 60 / 60)} часов ${Math.floor((wager.referral?.period ?? 0) / 60) % 60} минут ${(wager.referral?.period ?? 0) % 60} секунд`}
                    />

                    <h2>{t("ru.halls.wager.fortune_wheel.title")}</h2>
                    <Item
                        name={"ru.halls.wager.fortune_wheel.period"}
                        md={12}
                        value={`${wager.fortune_wheel.period === 0 ? "отключено" : `${Math.floor(wager.fortune_wheel.period / 60 / 60)} часов ${Math.floor(wager.fortune_wheel.period / 60) % 60} минут ${wager.fortune_wheel.period % 60} секунд`}`}
                    />
                    <Item name={"ru.halls.wager.fortune_wheel.minDeposit"} md={12} value={`${wager.fortune_wheel.minDeposit}`} />
                    <Item name={"ru.halls.wager.fortune_wheel.wager"} md={12} value={`${wager.fortune_wheel.wager ?? 0}%`} />

                    <FortuneWheelTable sectors={wager.fortune_wheel.sectors} />
                </Container>
            )}
        </Box>
    );
};

export default WagersView;